import { Card, Col, Row, Statistic, Typography } from 'antd';
import { crmBrandName, crmEnvLabel, crmPublicHost } from '../../branding/crmBrand';

export default function DashboardPage() {
  return (
    <div>
      <Typography.Title level={3} style={{ marginTop: 0, fontWeight: 700 }}>
        {crmBrandName} 營運儀表板
      </Typography.Title>
      <Typography.Paragraph type="secondary" style={{ fontSize: 15, marginBottom: 20 }}>
        {crmEnvLabel} ·
        {' '}
        車輛分佈、派單效率、Stripe/PayPal 對帳報表將在此擴展；API 已預留 maps / payments / locations 模組。
      </Typography.Paragraph>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12} xl={8}>
          <Card className="crm-page-card">
            <Statistic title="環境" value={crmEnvLabel} />
          </Card>
        </Col>
        <Col xs={24} md={12} xl={8}>
          <Card className="crm-page-card">
            <Statistic title="域名" value={crmPublicHost} />
          </Card>
        </Col>
        <Col xs={24} md={24} xl={8}>
          <Card className="crm-page-card">
            <Statistic title="派單級別邏輯" value="管理員 2 秒 → 合作方 → 公海" />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
